type extraParams = {
    workOrderNo?: string;
    [key: string]: any;
};

export default function useTimer(): {
    call: (phone: string, extraParams?: extraParams) => void;
} {
    // const [softPhoneUtils, setSoftPhoneUtils] = useState<any>();

    // useEffect(() => {
    //     setSoftPhoneUtils(SoftPhoneUtils());
    // }, []);

    const call = (phone: string, extraParams?: extraParams) => {
        if (!phone) {
            return;
        }
        window.softPhoneUtils?.call({
            tel: phone,
            extraParams,
        });
    };

    return { call };
}
